// @core/api/endpoints/bootstrap/test_ldap_connection.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestLdapConnectionRequest,
  TestLdapConnectionResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Test LDAP connection
 * Tests connectivity to the LDAP server with provided bind credentials. Performs bind and a test user search.
 * @public This endpoint does not require authentication
 */
export async function TestLdapConnection(
  data: TestLdapConnectionRequest,
  options?: RequestOptions
): Promise<TestLdapConnectionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/security/test-ldap`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TestLdapConnectionResponse>(requestPath, data, requestOptions);
}
